import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { BaseActivity, BaseActivityText } from '@/components/activities/BaseActivity/BaseActivity';
import IconShipmentNew from '@/icons/ShipmentNew.svg';

import { Link } from '../Link/Link';

export const ShipmentCreatedActivity = ({
  activity,
  isShipment,
}: {
  activity: ActivityOfType<'shipment_created'>;
  isShipment: boolean;
}) => {
  const creatorName = activity.creator?.name;

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      icon={<IconShipmentNew />}
      type="primary"
      message={
        <BaseActivityText>
          {isShipment ? (
            activity.creator ? (
              <Trans id="activities.shipment_created.created_the_shipment">
                <strong>{creatorName}</strong> created the shipment
              </Trans>
            ) : (
              <Trans id="activities.shipment_created.no-creator">The shipment was created</Trans>
            )
          ) : activity.creator ? (
            <>
              <Trans id="activities.shipment_created.created_a_shipment">
                <strong>{creatorName}</strong> created a{' '}
                <Link to={`/shipments/${activity.shipmentId}`} className="text-link">
                  shipment
                </Link>
              </Trans>
            </>
          ) : (
            <Trans id="activities.shipment_created.no-creator_a_shipment">
              A{' '}
              <Link to={`/shipments/${activity.shipmentId}`} className="text-link">
                shipment
              </Link>{' '}
              was created
            </Trans>
          )}
        </BaseActivityText>
      }
    />
  );
};
